<template>
  <div>
    <listado-modulos-tabla :data="dataDatatable" />
  </div>
</template>

<script>
// Vuex
import { mapState, mapActions } from "vuex";

import ListadoModulosTabla from "../../components/tablas/superadministrador/ListadoModulosTabla";

import { getModulos } from "../../constants/superadministrador";

export default {
  components: {
    ListadoModulosTabla,
  },
  data() {
    return {
      dataDatatable: [],
    };
  },
  computed: {
    ...mapState("superadministrador", ["dataDatatableModulosFiltrada"]),
  },
  methods: {
    // Acciones de Vuex
    ...mapActions(["AccionCambiar"]),
    ...mapActions("superadministrador", [
      "actionSetDataModulos",
      "actionSetDataModulosNombres",
      "actionSetDataModulosIconos",
    ]),

    // Función para actualizar url en state
    actualizarURL() {
      let me = this;
      me.AccionCambiar(this.$route.path);
    },

    // Obteneción de modulos desde la BD
    async getDataModulos() {
      // Consulta a API
      let dataModulosDB = await getModulos();
      this.actionSetDataModulos(dataModulosDB.data_table);

      //Filtros
      this.actionSetDataModulosNombres(
        Array.from(new Set(dataModulosDB.lista_nombre)).sort()
      ); // Filtra solo los datos unicos de un array;
      this.actionSetDataModulosIconos(
        Array.from(new Set(dataModulosDB.lista_iconos)).sort()
      ); // Filtra solo los datos unicos de un array;
    },
  },
  created() {
    this.getDataModulos();
    // Ejecución de actualizarURL una vez que se carga el componente
    this.actualizarURL();
  },
  watch: {
    dataDatatableModulosFiltrada: function (_new) {
      let me = this;
      // Si watch detecta un cambio en la variable dataDatatableFilialesFiltrada la cual es un state de vuex, esta asignada el nuevo
      // valor a la variable data
      if (_new) {
        me.dataDatatable = _new;
      }
    },
  },
};
</script>
